import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { XCircleIcon } from 'lucide-react';
const failedMethods = [{
  title: 'Pensar en positivo',
  description: 'No funciona porque tu cuerpo está desconectado de tu mente racional durante el pánico. Las frases motivacionales no detienen una respuesta fisiológica.'
}, {
  title: 'Ignorarlo',
  description: 'Solo hace que la presión aumente hasta que explota en un momento inoportuno. Reprimir no es solucionar.'
}, {
  title: 'Consejos genéricos',
  description: 'Decirle "cálmate" a alguien con ansiedad es como pedirle a alguien que deje de sangrar por pura voluntad. No funciona así.'
}, {
  title: 'Esperar a que pase solo',
  description: 'El sistema nervioso necesita un "reset" físico, no solo tiempo. Sin intervención, el ciclo se repite y se intensifica.'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5
    }
  }
};
export function FailedMethodsSection() {
  return <section className="py-24 px-4 sm:px-6 lg:px-8" data-id="element-28">
      <div className="max-w-5xl mx-auto" data-id="element-29">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} className="text-center mb-16" data-id="element-30">
          <h2 className="text-3xl sm:text-4xl font-heading font-bold text-brown mb-6" data-id="element-31">
            ¿Por qué lo que intentaste no funcionó?
          </h2>
          <p className="text-lg text-brown-light max-w-2xl mx-auto" data-id="element-32">
            Estos métodos fallan porque{' '}
            <strong className="text-terracotta font-medium" data-id="element-33">
              no atacan la raíz fisiológica
            </strong>{' '}
            de la ansiedad. Tu cuerpo necesita un reset físico, no solo mental.
          </p>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8" data-id="element-34">
          {failedMethods.map((method, index) => <motion.div key={index} variants={itemVariants} className="bg-white p-6 sm:p-8 rounded-2xl border border-sage-light shadow-sm" data-id="element-35">
              <div className="flex items-start gap-4" data-id="element-36">
                <div className="mt-1 bg-red-50 p-2 rounded-full text-terracotta flex-shrink-0" data-id="element-37">
                  <XCircleIcon className="w-6 h-6" data-id="element-38" />
                </div>
                <div data-id="element-39">
                  <h3 className="text-xl font-heading font-semibold text-brown mb-2" data-id="element-40">
                    {method.title}
                  </h3>
                  <p className="text-brown-light leading-relaxed" data-id="element-41">
                    {method.description}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}